import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-resume-settings',
    templateUrl: './resume-settings.component.html',
    styleUrls: ['./resume-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ResumeSettingsComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
